$(document).ready(function(){
  
$(".main-carousel").slick({
  infinite: true,
  autoplay: false,
  dots: true,
  arrows: true,
  adaptiveHeight: true,
  prevArrow: '<button class="absolute left-[-25px] top-[50%] z-10" aria-haspopup="true" aria-label="previous button banner"><img alt="previous cursor image" src="https://cdn.shopify.com/s/files/1/0497/8891/1770/t/39/assets/arrow-left.png"/></button>',
  nextArrow: '<button class="absolute right-[-25px] top-[50%] z-10"  aria-haspopup="true" aria-label="next button banner"><img  alt="next cursor image" src="https://cdn.shopify.com/s/files/1/0497/8891/1770/t/39/assets/arrow-right.png"/></button>'
});

  $('.dropdown-trigger').click(function(e) {
    e.preventDefault();
    var dropdown = $(this).attr('target-dropdown');
        dropdown = $(dropdown)
    console.log(dropdown)
    if(dropdown.hasClass('hidden')) {
      return dropdown.removeClass('hidden')
    }
    $(dropdown).addClass('hidden')
  })

  $('#loadmore').click(function(e) {
      e.preventDefault();
      var scrollNode = $('.product#more').last(); 
      var scrollURL = $('.product#more p a').last().attr("href");
       $.ajax({
       type: 'GET',
       url: scrollURL,
       success: function(data) {
           // remove loading feedback
           scrollNode.next().remove();
           var filteredData = $(data).find(".product");
           filteredData.insertBefore( $("#product-list-foot") );                   
       },
       dataType: "html"
   });
  });
  $('.add-to-cart-btn-qty').click(function(e) {
    e.preventDefault();
    var id = $(this).data("product-id");
    var product_type = $(this).data("product-type").toLowerCase();
    var qty = $('#input-qty').val();
    
    let location = localStorage.getItem('location');
        location = JSON.parse(location);
    
    let cart = $.ajax({ method: 'GET', url: '/cart.js', async: false }).responseText;
        cart = JSON.parse(cart);
    
    let changeLocation = false;
    
    if(changeLocation) {
      $.ajax({ method: 'GET', url: '/cart/clear.js', async: false });
      $.ajax({
        type: 'POST', 
        url: '/cart/update.js',
        dataType: 'json', 
        async: false,
        data: {
          "attributes": {
            "Pickup-Location-Id": location.id,
            "Pickup-Location-Company": location.name,
            "Pickup-Location-Address-Line-1": location.address1,
            "Pickup-Location-City": location.city,
            "Pickup-Location-Region": location.localized_country_name,
            "Pickup-Location-Postal-Code": location.zip,
            "Pickup-Location-Country": location.localized_country_name,
            "Pickup-Location-Province": location.localized_province_name,
            "Checkout-Method": "pickup"
          }
        },
        success: function(data) {
          console.log($('#select-location-detail-product').val());
          if($('#select-location-detail-product').val() === null) {
            $('#select-location-detail-product').val(location.id);
          }
        }  
      });
    }

    let is_able_to_add = false;

    // OSECHI HANDLER
    $.ajax({
      type: 'GET',
      url: '/cart.json',
      dataType: 'jsonp',
      async: false,
      success: function(data) {
        const items = data.items
        const osechi = 'osechi'
        const cake = 'christmascake'

        if(items.length > 0){
          const is_osechi_exist = items.some(item => item.product_type.toLowerCase() === osechi)
          const is_cake_exist = items.some(item => item.product_type.toLowerCase() === cake)
          
          if(is_osechi_exist && product_type == cake){
            is_able_to_add = false
          }else if(is_cake_exist && product_type == osechi){
            is_able_to_add = false
          }else{
            is_able_to_add = true
          }
        }else{
          is_able_to_add = true
        }
      }
    });

    if(is_able_to_add){
      $.ajax({
        type: 'POST', 
        url: '/cart/add.js',
        dataType: 'json', 
        data: {id:id ,quantity: qty},
        success: function() {
          getCartTotal();
          alert('Item added to cart.')
        }
     });
    }else{
      alert("Oops! Osechi Collection and Cake Collection can't be purchased together in the same order. Please place separate orders for each collection.")
    }

  })
  
  $('.add-to-cart-btn').click(function(e) {
    e.preventDefault()
    var id = $(this).data("product-id")
    var product_type = $(this).data("product-type").toLowerCase()

    let is_able_to_add = false

    // OSECHI HANDLER
    $.ajax({
      type: 'GET',
      url: '/cart.json',
      dataType: 'jsonp',
      async: false,
      success: function(data) {
        const items = data.items
        const osechi = 'osechi'
        const cake = 'christmascake'

        if(items.length > 0){
          const is_osechi_exist = items.some(item => item.product_type.toLowerCase() === osechi)
          const is_cake_exist = items.some(item => item.product_type.toLowerCase() === cake)
          
          if(is_osechi_exist && product_type == cake){
            is_able_to_add = false
          }else if(is_cake_exist && product_type == osechi){
            is_able_to_add = false
          }else{
            is_able_to_add = true
          }
        }else{
          is_able_to_add = true
        }
      }
    });

    if(is_able_to_add){
      $.ajax({
        type: 'POST', 
        url: '/cart/add.js',
        dataType: 'json', 
        data: {id:id ,quantity: 1},
        success: function() {
          getCartTotal()
          alert('Item added to cart.')
        }
     });
    }else{
      alert("Oops! Osechi Collection and Cake Collection can't be purchased together in the same order. Please place separate orders for each collection.")
    }
  })
  

  function getCartTotal() {
  $.ajax({
    type: 'GET',
    url: '/cart.json',
    dataType: 'jsonp',
    success: function(data) { 
        var item_count = data['item_count'];
       var total_price = data['total_price']/100;
      $('#count_cart').text(item_count);
      $('.cart_totals').text(total_price);
      document.querySelector('.cart_totals').value = total_price;
    }
});
  }
});
